import React from 'react';
import { string, node } from 'prop-types';
import cx from 'classnames';

import segmentStatus from 'propTypes/segmentStatus';
import styles from './GridItem.scss';

/**
 * Note that order of title and content is reversed by CSS in order to keep
 * markup correct.
 */
export default function GridItem({ label, children, status }) {
  return (
    <dl
      className={cx(styles.main, {
        [styles[`status-${status}`]]: Boolean(status),
      })}
    >
      <dt className={styles.label}>
        {label}
      </dt>
      <dd className={styles.content}>
        {children}
      </dd>
    </dl>
  );
}

GridItem.propTypes = {
  label: string.isRequired,
  children: node.isRequired,
  status: segmentStatus,
};



// WEBPACK FOOTER //
// ./src/components/DataPanel/GridItem/index.js